import { render, staticRenderFns } from "./KigeLogin.vue?vue&type=template&id=7a4cde7a&scoped=true&"
import script from "./KigeLogin.vue?vue&type=script&lang=js&"
export * from "./KigeLogin.vue?vue&type=script&lang=js&"
import style0 from "./KigeLogin.vue?vue&type=style&index=0&id=7a4cde7a&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a4cde7a",
  null
  
)

export default component.exports